module.exports = __webpack_public_path__ + "img/Nils.962ca283.png";